app.factory("Subject", ["$http",
    function ($http) {
        var Subject = {};

        Subject.list = function (params) {
            params = params || {};
            params.limit = params.limit || 10;
            return $http.get("/subject/list", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    query: params.query,
                    level: params.level,
                    prerequisite: params.prerequisite
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        Subject.activeList = function (params) {
            params = params || {};
            params.limit = params.limit || 10;
            return $http.get("/subject/active/list", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    query: params.query,
                    level: params.level
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        Subject.create = function (params) {
            return $http.post("/subject/create", {
                name: params.name,
                author: params.author,
                code: params.code,
                credits: params.credits,
                level: params.level,
                prerequisites: params.prerequisites,
                gradeTemplate: params.gradeTemplate,
                syllabusFile: params.syllabusFile
            }).then(function () {
                return true;
            });
        };

        Subject.update = function (params) {
            return $http.post("/subject/update", {
                _id: params._id,
                name: params.name,
                nameEN: params.nameEN,
                code: params.code,
                author: params.author,
                credits: params.credits,
                level: params.level,
                prerequisites: params.prerequisites,
                gradeTemplate: params.gradeTemplate,
                syllabusFile: params.syllabusFile
            }).then(function () {
                return true;
            });
        };

        Subject.remove = function (subjectId) {
            return $http.post("/subject/remove", {
                id: subjectId
            }).then(function (resp) {
                return resp.data;
            });
        };

        Subject.fetchOne = function (subjectId) {
            return $http.get("/subject/one/" + subjectId).then(function (resp) {
                return resp.data;
            });
        };

        Subject.wrappersList = function (params) {
            params = params || {};
            params.limit = params.limit || 10;
            return $http.get("/subject/wrapper/list", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    query: params.query,
                    program: params.program
                }
            }).then(function (resp) {
                return resp.data;
            });

        };

        Subject.details = function (subject, params) {
            params = params || {};
            params.limit = params.limit || 10;
            return $http.get("/subject/details/" + subject, {
                params: {
                    page: params.page,
                    limit: params.limit,
                    query: params.query,
                    faculty: params.faculty,
                    level: params.level,
                    state: params.state,
                    subjectState: params.subjectState,
                    program: params.program,
                    semester: params.semester
                }
            }).then(function (resp) {
                return resp.data;
            });

        };

        return Subject;
    }
]);
